import { render } from "./ProductSpecBOM.vue?vue&type=template&id=7d116b5f"
import script from "./ProductSpecBOM.vue?vue&type=script&lang=js"
export * from "./ProductSpecBOM.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__